import { render } from "./StepVerifica.vue?vue&type=template&id=5e2f992e"
import script from "./StepVerifica.vue?vue&type=script&lang=js"
export * from "./StepVerifica.vue?vue&type=script&lang=js"

import "./StepVerifica.vue?vue&type=style&index=0&id=5e2f992e&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__